/*
 * @Author: wzc
 * @Date: 2024-03-22 10:42:36
 * @LastEditors: wzc
 * 超赛平台 base mixins
 * @LastEditTime: 2021-10-25 19:11:02
 * 将创建主题的方法抽离出来, 无论容器的还是其他地方，最终调用分享api都在这里
 */
import { https_package_createDataItem } from '@api/platfrom_base_api'
export default {
  data() {
    return {}
  },
  methods: {
    async createDataItem(item, addParams) {
      //分享主题到【播出单|数据包装】
      console.debug('createDataItem:', item, addParams)
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      let analysisItemStyles = []
      if (item.analysisItemStyles) {
        item.analysisItemStyles.forEach((styleItem) => {
          if (styleItem.act) {
            analysisItemStyles.push(styleItem.styleId)
          }
        })
      }
      if (item.actJson?.channels) {
        let channels = item.actJson.channels.filter(
          (i) => i !== '' && i !== null && i !== undefined
        )
        item.actJson.channels = channels.length ? channels : undefined
      }
      const query = {
        analysisItemId: item.analysisItemId,
        groupId: this.platfromMenu_currGroup.groupId,
        competitionId: this.currCid,
        seasonId: item.crossSeason
          ? 0
          : addParams.sid
          ? addParams.sid
          : this.currSid, //为true是跨赛季所以赛季id传0，false不跨赛季所以传当前赛季id
        disciplineId: item.sportsId ? item.sportsId : 0,
        eventId: item.eventId ? item.eventId : 0,
        phaseId: item.phaseId ? item.phaseId : 0,
        matchId: item.seasonOrMatch ? addParams.mid : 0, //seasonOrMatch为true需要传matchId，为false则赛事主题传0
        analysisType: item.analysisType,
        json: item.actJson
          ? JSON.stringify(item.actJson)
          : item.json
          ? JSON.stringify(JSON.parse(item.json))
          : '',
        seasonOrMatch: item.seasonOrMatch,
        dataItemName: item.analysisItemName ? item.analysisItemName : '',
        dataImg: item.dataImg ? item.dataImg : '',
        packageId: addParams.roomId,
        broadcastId: addParams.playerItemId,
        analysisItemStylesJson: JSON.stringify(analysisItemStyles), //主题的设计风格
        filterTypeNameLabel: JSON.stringify(item.filterTypeNameLabel), //传递标题
      }
      const localBaseUrl = this.currSid === 'ASG2026' ? '/games' : this.axiosBaseUrl
      await https_package_createDataItem(localBaseUrl, this.$axios, query)
        .then((response) => {
          const res = response.data
          console.debug(res)
          if (res.status === 0) {
            console.debug('添加成功')
            this.$message({
              showClose: true,
              message: '添加成功',
              type: 'success',
              // duration: 0,
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    createThemeItemBreforToFormat(needPublicThemeData, data) {
      // 创建主题时，所有主题共用的格式化逻辑， 在containerFull_common_data 和 complex_multipleChoiceShare_dialog 中有各自单独定制化的格式化逻辑

      // 动态拼接标题
      // dataDimension[下拉框的字段]: filter.filterTypes 里面的字段
      // 自定义字符串的标识就是 【!$】 直接取后面的字符串使用
      // title: 原标题名字
      // needPublicThemeData.titleJoinKey | needPublicThemeData.renderData.titleJoinKey = ['dataDimension', '!$-', 'title']
      // 访问发布主题接口
      console.debug('createThemeItemBreforToFormat:', needPublicThemeData)
      // 为了兼容积分榜这种没有getMore的情况，将 titleJoinKey 放到了 最外层
      // 像积分榜这种主题分析项和主题数据分开的， needPublicThemeData中是没有 renderData 的，因为 renderData 是在 getMore 中获取后赋值成 renderData
      // 优先级 titleJoinKey ：  needPublicThemeData.renderData.titleJoinKey > needPublicThemeData.titleJoinKey
      let titleJoinKeyArr = null
      if (needPublicThemeData) {
        titleJoinKeyArr = needPublicThemeData.titleJoinKey
          ? JSON.parse(needPublicThemeData.titleJoinKey)
          : null
        if (
          needPublicThemeData.renderData &&
          needPublicThemeData.renderData.titleJoinKey
        ) {
          titleJoinKeyArr = JSON.parse(
            needPublicThemeData.renderData.titleJoinKey
          )
        }
      }
      if (titleJoinKeyArr && titleJoinKeyArr.length > 0) {
        let themeSharedAfterTitleName = ''
        titleJoinKeyArr.forEach((key) => {
          if (key.indexOf('!$') > -1) {
            // 自定义字符串的标识就是 【!$】 直接取后面的字符串使用
            themeSharedAfterTitleName += key.substring(2)
          } else if (key === 'title') {
            themeSharedAfterTitleName += needPublicThemeData.analysisItemName
              ? needPublicThemeData.analysisItemName //analysisItemName 在打开分享弹窗时已经将 renderData.title 中的值覆盖了原来的 analysisItemName
              : ''
          } else {
            let curKeyId =
              needPublicThemeData.actJson && needPublicThemeData.actJson[key]
                ? needPublicThemeData.actJson[key]
                : ''
            let curKeyVal = ''
            if (
              needPublicThemeData.filter &&
              needPublicThemeData.filter.filterTypes
            ) {
              const arr = needPublicThemeData.filter.filterTypes
              arr.forEach((selectOpt) => {
                if (selectOpt.name === key && selectOpt.values) {
                  selectOpt.values.forEach((selectItem) => {
                    console.debug(
                      'createThemeItemBreforToFormat:',
                      key,
                      selectItem,
                      curKeyId
                    )
                    if (selectItem.value === curKeyId) {
                      curKeyVal = selectItem.name
                    }
                  })
                }
              })
            }
            themeSharedAfterTitleName += curKeyVal
          }
        })
        needPublicThemeData.analysisItemName = themeSharedAfterTitleName
      }

      // 设置标签
      const filterTypeLabelKeyArr =
        needPublicThemeData &&
        needPublicThemeData.renderData &&
        needPublicThemeData.renderData.filterTypeLabel
          ? JSON.parse(needPublicThemeData.renderData.filterTypeLabel)
          : null

      if (filterTypeLabelKeyArr && filterTypeLabelKeyArr.length > 0) {
        let filterTypeNameLabel = []
        filterTypeLabelKeyArr.forEach((key) => {
          let curKeyId =
            needPublicThemeData.actJson && needPublicThemeData.actJson[key]
              ? needPublicThemeData.actJson[key]
              : ''
          let curKeyVal = ''
          if (
            needPublicThemeData.filter &&
            needPublicThemeData.filter.filterTypes
          ) {
            const arr = needPublicThemeData.filter.filterTypes
            arr.forEach((selectOpt) => {
              if (selectOpt.name === key && selectOpt.values) {
                selectOpt.values.forEach((selectItem) => {
                  console.debug(
                    'createThemeItemBreforToFormat:',
                    key,
                    selectItem,
                    curKeyId
                  )
                  if (selectItem.value === curKeyId) {
                    curKeyVal = selectItem.name
                  }
                })
              }
            })
          }
          filterTypeNameLabel.push({
            key: key,
            id: curKeyId,
            label: curKeyVal,
          })
        })
        console.debug('filterTypeNameLabel:', filterTypeNameLabel)
        needPublicThemeData.filterTypeNameLabel = filterTypeNameLabel
      }

      needPublicThemeData.analysisItemStyles = data.data.analysisItemStyles
      return needPublicThemeData
    },
  },
}
